import { takeEvery } from 'redux-saga/effects';
import { fetchReportData } from './fetch-report-data';
import { fetchParcel } from './fetch-parcel';
import { fetchMultiParcel } from './fetch-multi-parcel';
import { downloadCSV } from './download-csv';
import { downloadShapefile } from './download-shapefile';
import { fetchComputed } from './fetch-computed';

export function* downloadCSVSaga() {
  yield takeEvery('DOWNLOAD_CSV', downloadCSV);
}
export function* downloadShapefileSaga() {
  yield takeEvery('DOWNLOAD_SHAPEFILE', downloadShapefile);
}

export function* openReportSaga() {
  yield takeEvery('OPEN_PARCEL_REPORT', fetchReportData);
}

export function* fetchComputedSaga() {
  yield takeEvery('FETCH_COMPUTED', fetchComputed);
}

export function* openParcelReportSaga() {
  yield takeEvery('FETCH_PARCEL_FOR_REPORT', fetchParcel);
}

export function* openMultiParcelReportSaga() {
  yield takeEvery('FETCH_MULTI_PARCEL_REPORT', fetchMultiParcel);
}
